/* src/app/_shared/components/loader/loader.component.scss */
:host {
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000000;
  width: 100vw;
  height: 100vh;
}
.flow-loader {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  height: 100%;
}
.flow-loader .loader-backdrop {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 10000001;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
}
.flow-loader .loader-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 10000002;
  height: 150px;
  width: 150px;
  border-radius: var(--radius);
  background-color: #FFFFFF;
}
.flow-loader .loader-container .spinner-screen {
  height: 100px;
  width: 100px;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10000002;
  margin: auto;
  animation: rotate 2s linear infinite;
  transform-origin: center center;
}
.flow-loader .loader-container .spinner-screen .path {
  stroke-dasharray: 1, 200;
  stroke-dashoffset: 0;
  animation: dash 1.5s ease-in-out infinite;
  stroke-linecap: round;
  stroke: var(--ion-color-action);
}
@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}
@keyframes dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35px;
  }
  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124px;
  }
}
/*# sourceMappingURL=loader.component.css.map */
